// TODO: add support for from / size params
const search = (options) => {
  const url = `${window.location.origin}/${options.index}/_search`
  const requestBody = {size: options.size, from: options.from, ...options.body}

  return fetch(url, {
    method: 'POST',
    headers: {"Content-type": "application/json"},
    body: new Blob([JSON.stringify(requestBody, null, 2)], {type : 'application/json'}),
  })
    .then(response => response.json())
    .then(data => {
        return data
    })
}

export const preprocessQueryString = (input) => (
  input
    .replace(/[\<\>]/g, '') // remove banned chars
    .replace(/([\+\-\=\!\(\){\}\[\]\^\"\~\*\?\:\/\\])/g, '\\$1') // escape reserved chars
    .trim() // remove outer spaces
    .replace(/ +|$/g,'~ ') // add fuzzies but ignore double spaces
)

export default search



// WEBPACK FOOTER //
// ./app/javascript/lib/elastic-search.js